
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { pushEventToGTM } from '../../../helpers/trackerManager';

import Icon from '../../buttons/Icon';


class TabInfoSection extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      'showDetails': false,
    };
  }


  render() {
    const { title, children } = this.props;
    return (

      <div className="infos-wrapper"
        tabIndex='0'
        onKeyDown={e => {
          if (e.key === 'Enter') {
            this.setState({ showDetails: !this.state.showDetails });
            pushEventToGTM({
              pageName: 'car-details',
              eventAction: 'Display::Help',
              eventLabel: title
            });
          }
        }
        }
        onClick={() => {
          this.setState({ showDetails: !this.state.showDetails });
          pushEventToGTM({
            pageName: 'car-details',
            eventAction: 'Display::Help',
            eventLabel: title
          });
        }}>
        <div className="infos-header">

          <p dangerouslySetInnerHTML={{ __html: (title) }}></p>
          <Icon Name="info" />
        </div>
        {this.state.showDetails && <div className="infos-body">
          <p>{children}</p>
        </div>}
      </div>

    );
  }
}
export default TabInfoSection;
